/**
 * @typedef {String} module:EventService.GarageSpotActionEnum
 * @readonly
 * @description Garage spot actions
 * @property {String} enter
 * @property {String} exit
 */
const garageSpotActionEnum = Object.freeze({
    enter: 'enter',
    exit: 'exit'
});

export default garageSpotActionEnum;
